import auth from "../../api/auth";

// initial state
const state = {
  user: {}
};

// getters
const getters = {
  user: state => state.user,
  isAuthenticated: state => !!state.user.userId,
  isAuthorized: (state, getters) => roles => {
    if (!Array.isArray(roles)) {
      roles = [roles];
    }
    // if route requires any roles, but user has none, return false
    if (roles.length > 0 && !state.user.userRoles) {
      return false;
    }
    var userRoleCount = 0;
    //for each item in authorizedRoles, check if Session.userRoles has it
    for (var i = 0; i < roles.length; i++) {
      if (roles[i] == "*" && state.user.userRoles.length) userRoleCount += 1;
      else if (state.user.userRoles.indexOf(roles[i]) !== -1)
        userRoleCount += 1;
    }
    return getters.isAuthenticated && userRoleCount > 0;
  }
};

// actions
const actions = {
  getUser({ commit }) {
    return auth.getUser(user => {
      commit("setUser", user);
    });
  }
};

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
